import React from 'react';
import styled from 'styled-components';
import { AuditLog, Loader } from '@ubeya/shared-web/components';
import useAuditLogs from '@ubeya/shared/hooks/account/useAuditLogs';
import { RootContainer, RootWrapper } from '../styled';
import Header from './Header';

const Wrapper = styled.div`
  overflow: auto;
`;

const EmployeeAuditLogs = ({ data: employeeData }) => {
  const { id: employeeId } = employeeData || {};

  const { isLoading, data } = useAuditLogs({
    employeeIds: [employeeId].filter((id) => !!id),
    pageSize: Number.MAX_SAFE_INTEGER
  });

  return (
    <RootWrapper>
      <RootContainer>
        <Header data={data} />

        <Wrapper>
          {data.map(({ type, data: currentData, ...rest }, index) => (
            <AuditLog key={index} type={type} data={{ data: JSON.parse(currentData), ...rest, type }} />
          ))}
        </Wrapper>

        {isLoading && <Loader />}
      </RootContainer>
    </RootWrapper>
  );
};

export default React.memo(EmployeeAuditLogs);
